<div *ngIf="isLoading" id="loader-backdrop">
  <div id="loader-container">
    <!-- <p id="loadingText">Loading</p> -->
    <img src="/assets/images/logo-mark.svg" alt="Loading" id="loadingText" />
  </div>
</div>